import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { RoadmapApi } from './apis/roadmap-api';
import { RoadmapApiImpl } from './apis/impls/roadmap-api';
import { RoadmapRepository } from './services/roadmap-repository';
import { RoadmapRepositoryImpl } from './repositories/impls/roadmap-repository';

export const roadmapContainer = new ContainerModule(bind => {
    bind(RoadmapRepository).to(RoadmapRepositoryImpl);
    bind(RoadmapApi).to(RoadmapApiImpl);
});
